import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18next BEFORE App
import App from './App';
import { AppErrorBoundary } from './components/error/AppErrorBoundary';
import { SplashScreen } from './components/SplashScreen';
import { ConfigLoaderProvider } from './contexts/ConfigLoaderContext';
import { validateApiConfig } from '@/config/api.config';

// Validate API configuration before rendering app
validateApiConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigLoaderProvider>
      <SplashScreen>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </SplashScreen>
    </ConfigLoaderProvider>
  </React.StrictMode>
);
